'use client';
import React, { useEffect, useState } from "react"
import TawkMessengerReact from "@tawk.to/tawk-messenger-react"

const Chat = () => {
  const [isProduction, setIsProduction] = useState(false);

  useEffect(() => {
    // Only enable Tawk.to in production and not on localhost
    const isProductionEnv = process.env.NODE_ENV === 'production' && 
                           typeof window !== 'undefined' && 
                           window.location.hostname !== 'localhost' && 
                           window.location.hostname !== '127.0.0.1';
    setIsProduction(isProductionEnv);
  }, []);

  if (!isProduction) {
    console.log('Tawk.to chat disabled in development/localhost mode');
    return null;
  }

  return (
    <TawkMessengerReact
      propertyId="5966035b1dc79b329518ddf4/"
      widgetId="default"
      onBeforeLoad={() => {
        // Optional callback before Tawk.to loads
      }}
      onStatusChange={(status: any) => {
        // Optional callback when status changes
        console.log('Tawk status changed:', status);
      }}
      onChatMaximized={() => {
        // Optional callback when chat is maximized
      }}
      onChatMinimized={() => {
        // Optional callback when chat is minimized
      }}
      onChatHidden={() => {
        // Optional callback when chat is hidden
      }}
      onChatStarted={() => {
        // Optional callback when chat is started
      }}
      onChatEnded={() => {
        // Optional callback when chat is ended
      }}
      onPrechatSubmit={() => {
        // Optional callback when prechat form is submitted
      }}
      onOfflineSubmit={() => {
        // Optional callback when offline form is submitted
      }}
      onChatMessageVisitor={() => {
        // Optional callback when visitor sends a message
      }}
      onChatMessageAgent={() => {
        // Optional callback when agent sends a message
      }}
      onChatMessageSystem={() => {
        // Optional callback when system sends a message
      }}
      onAgentJoinChat={() => {
        // Optional callback when agent joins chat
      }}
      onAgentLeaveChat={() => {
        // Optional callback when agent leaves chat
      }}
      onChatSatisfaction={() => {
        // Optional callback for chat satisfaction
      }}
      onVisitorNameChanged={() => {
        // Optional callback when visitor name changes
      }}
      onFileUpload={() => {
        // Optional callback when file is uploaded
      }}
      onTagsUpdated={() => {
        // Optional callback when tags are updated
      }}
      onUnreadCountChanged={() => {
        // Optional callback when unread count changes
      }}
    />
  )
}

export default Chat
